<template>
  <div v-if="shouldShow" class="alert alert-warning mb-0 text-center" role="alert">
    We will be performing scheduled maintenance on {{ utcDate }}. You may be unable to access this website while maintenance is being performed.
  </div>
</template>

<script>
const MAINTENANCE_START = "2026-11-01T22:00:00Z"; // ISO 8601 offset, timezone-safe
const BANNER_DURATION_AFTER_START_MS = 24 * 60 * 60 * 1000; // keep showing for 1 day after start

export default {
  name: "MaintenanceBanner",
  computed: {
    shouldShow() {
      return Date.now() <= new Date(MAINTENANCE_START).getTime() + BANNER_DURATION_AFTER_START_MS;
    },
    utcDate() {
      const date = new Date(MAINTENANCE_START);
      const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
      const day = date.getUTCDate();
      const suffix = day % 10 === 1 && day !== 11 ? "st"
        : day % 10 === 2 && day !== 12 ? "nd"
        : day % 10 === 3 && day !== 13 ? "rd"
        : "th";
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      return `${month} ${day}${suffix}, ${date.getUTCFullYear()}, at ${hours}:${minutes} UTC`;
    },
  },
};
</script>
